import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import classes from './termsAndConditions.module.css';
import { sixYardAxios } from "../../sixYardAxios";

const TermsAndConditions = (props) => {
    const [termsData, setTermsData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        console.log('Current language:', props.language);
        fetchTermsAndConditions();
    }, [props.language]);

    const fetchTermsAndConditions = async () => {
        try {
            const response = await sixYardAxios.get("/terms-conditions");
            console.log('API Response:', response.data.data);
            setTermsData(response.data.data);
        } catch (error) {
            console.error("Failed to fetch terms and conditions:", error);
        } finally {
            setLoading(false);
        }
    };

    const renderContent = () => {
        if (loading) {
            return <div>Loading...</div>;
        }

        if (!termsData) {
            return <div>No terms and conditions available.</div>;
        }

        console.log('Terms Data:', termsData);
        console.log('Current Language in render:', props.language);

        let content;
        // 0 is Arabic, 1 is English
        if (props.language === 0 && termsData.content_ar) {
            content = termsData.content_ar;
            console.log('Using Arabic content');
        } else {
            content = termsData.content;
            console.log('Using English content');
        }
        
        return (
            <div 
                dangerouslySetInnerHTML={{ __html: content }}
                className={classes.termsContent}
                dir={props.language === 0 ? 'rtl' : 'ltr'}
            />
        );
    };

    return (
        <div className={classes.Container}>
            {renderContent()}
        </div>
    );
}

const mapStateToProps = state => {
    console.log('Redux State:', state);
    return {
        language: state.home.selected_language,
    };
};

export default connect(mapStateToProps)(TermsAndConditions);